module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1525-bf2a42469df28b161df793a8d6c23f21.png";